import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useCreditNoteCard = (creditNote) => {
  return useQuery({
    queryKey: ["invoiceCardState", creditNote],
    queryFn: async () =>
      callApi({
        path: "crmemocard",
        command: "",
        data: JSON.stringify({
          data: { filter: { noFilter: creditNote } },
        }),
      }),
  });
};
